import { styled, TextField } from "@mui/material";

export const CustomInput = styled(TextField)`
  border-radius: 4px;
  & .Mui-error {
    margin-left: 0;
  }
`;
